import _ from 'lodash';
import ValidationUtils from './ValidationUtils';
import Messages from './Messages';

const CheckoutValidator = (values) => {
  const requiredFields = [{
    name: 'firstName',
    errorMessage: Messages.REQUIRED_FIRST_NAME
  }, {
    name: 'lastName',
    errorMessage: Messages.REQUIRED_LAST_NAME
  }, {
    name: 'email',
    errorMessage: Messages.REQUIRED_EMAIL
  }, {
    name: 'contactNumber',
    errorMessage: Messages.REQUIRED_PHONE
  }, {
    name: 'password',
    errorMessage: Messages.REQUIRED_PASSWORD
  }, {
    name: 'confirmPassword',
    errorMessage: Messages.REQUIRED_CONFIRM_PASSWORD
  }, {
    name: 'connectionDate',
    errorMessage: Messages.REQUIRED_CONNECTION_DATE
  }, {
    name: 'currentBroadbandProvider',
    errorMessage: Messages.REQUIRED_CURRENT_BROADBAND_PROVIDER
  }, {
    name: 'providerAccountNumber',
    errorMessage: Messages.REQUIRED_PROVIDER_ACCOUNT_NUMBER
  }, {
    name: 'landline',
    errorMessage: Messages.REQUIRED_SELECT
  }, {
    name: 'modemDelivery',
    errorMessage: Messages.REQUIRED_CHOICE
  }, {
    name: 'acceptTerms',
    errorMessage: Messages.REQUIRED_ACCEPT_TERMS
  }];

  const deliveryAddressRequiredFields = [{
    name: 'modemName',
    errorMessage: Messages.REQUIRED_NAME
  }, {
    name: 'modemAddress',
    errorMessage: Messages.REQUIRED_ADDRESS
  }, {
    name: 'modemSuburb',
    errorMessage: Messages.REQUIRED_SUBURB
  }, {
    name: 'modemCity',
    errorMessage: Messages.REQUIRED_CITY
  }, {
    name: 'modemPostcode',
    errorMessage: Messages.REQUIRED_POSTCODE
  }];

  let errors = ValidationUtils.validateRequiredFields(requiredFields, values);

  if (values.firstName && !ValidationUtils.isValidName(values.firstName)) {
    errors.firstName = Messages.INVALID_NAME;
  }

  if (values.lastName && !ValidationUtils.isValidName(values.lastName)) {
    errors.lastName = Messages.INVALID_NAME;
  }

  if (values.email && !ValidationUtils.isValidEmailAddress(values.email)) {
    errors.email = Messages.INVALID_EMAIL;
  }

  if (values.contactNumber && !ValidationUtils.isValidPhoneNumber(values.contactNumber)) {
    errors.contactNumber = Messages.INVALID_PHONE;
  }

  if (values.password && !ValidationUtils.hasUpperCaseCharacter(values.password)) {
    errors.password = Messages.INVALID_PASSWORD_UPPERCASE;
  }

  if (values.password && !ValidationUtils.containsNumber(values.password)) {
    errors.password = Messages.INVALID_PASSWORD_NUMBER;
  }

  if (values.password && values.password.length < 8) {
    errors.password = Messages.INVALID_PASSWORD_LENGTH;
  }
  if (values.providerAccountNumber &&
     (values.providerAccountNumber.length < 4 || values.providerAccountNumber.length > 80)) {
    errors.providerAccountNumber = Messages.INVALID_PROVIDER_ACCOUNT_NUMBER;
  }

  if (values.password && values.confirmPassword && values.password !== values.confirmPassword) {
    errors.confirmPassword = Messages.INVALID_PASSWORD_MATCH;
  }

  if (values.connectionDate && values.connectionDate === 'preferred') {
    errors = _.merge(errors, ValidationUtils.validateRequiredFields([{
      name: 'preferredDate',
      errorMessage: Messages.REQUIRED_CONNECTION_DATE
    }], values));
  }

  if (values.isEssentialService) {
    errors = _.merge(errors, ValidationUtils.validateRequiredFields([{
      name: 'essentialServiceType',
      errorMessage: Messages.REQUIRED_SELECT
    }, {
      name: 'essentialServiceReason',
      errorMessage: Messages.REQUIRED_FIELD
    }], values));
  }

  if (values.landline && values.landline === 'yes') {
    errors = _.merge(errors, ValidationUtils.validateRequiredFields([{
      name: 'existingLandlineProvider',
      errorMessage: Messages.REQUIRED_CURRENT_LANDLINE_PROVIDER
    }], values));
  }

  if (values.modemDelivery && values.modemDelivery === 'different') {
    errors = _.merge(errors, ValidationUtils.validateRequiredFields(deliveryAddressRequiredFields, values));

    if (values.modemPostcode && !ValidationUtils.containsOnlyNumbers(values.modemPostcode)) {
      errors.modemPostcode = Messages.INVALID_POSTCODE;
    }
  }

  return errors;
};

export default CheckoutValidator;



/** WEBPACK FOOTER **
 ** ./src/common/validation/CheckoutValidator.js
 **/